import { useEffect, useState } from "react";

import { Button } from "Components/atoms/Button";
import { Typography } from "Components/atoms/Typography";
import { CarouselDesktop } from "Components/organisms/Carousel/Desktop";
import { CarouselMobile } from "Components/organisms/Carousel/Mobile";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

import {
  StyledCTAWrapper,
  StyledHeroWrapper,
  StyledPromotionTitle,
  StyledSubtitleWrapper,
  StyledTitleWrapper,
} from "./styles";

/**
 * URL para o Voopter Achados
 */
const URL_VOOPTER_CLUB =
  "https://achados.voopter.com.br/?utm_source=voopter-botao-home";

/**
 * URL para o Voopter Club
 */
const URL_MORE_OFFERS = "https://voopter.com.br/passagens-aereas-promocionais";

/**
 * Rótulo do botão CTA
 */
const LABEL_BUTTON = "ver mais achados";

/**
 * Componente PromotionsCarouselTemplate
 *
 * Renderiza uma seção promocional com título, subtítulo, carrossel e botão de ação.
 */
export function PromotionsCarouselTemplate() {
  const [desktop, setDesktop] = useState(false);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    setDesktop(
      breakpoint === "xxl" || breakpoint === "xl" || breakpoint === "lg",
    );
  }, [breakpoint]);

  /**
   * Redireciona o usuário para o Voopter Club.
   */
  function goToVoopterClub() {
    window.open(URL_VOOPTER_CLUB, "_blank", "noreferrer");
  }

  return (
    <StyledHeroWrapper>
      {/* Título */}
      <StyledTitleWrapper>
        <StyledPromotionTitle>
          Junte-se aos Achados e economize nas suas viagens.
        </StyledPromotionTitle>

        {/* Subtítulo */}
        <Typography variant="body" align="left" color="black">
          Se inscreva gratuitamente e te ajudamos a encontrar as melhores
          ofertas de passagens aáreas. Viajar mais e gastar menos!
        </Typography>
      </StyledTitleWrapper>

      {/* Carrossel */}
      {desktop ? <CarouselDesktop /> : <CarouselMobile />}

      {/* Botão CTA */}
      {/* <StyledCTAWrapper>
        <Button
          label={LABEL_BUTTON}
          backgroundColor="yellow"
          fontWeight="medium"
          size={desktop ? "large" : "small"}
          color="mediumGray"
          uppercase
          rounded
          onClick={goToVoopterClub}
        />
      </StyledCTAWrapper> */}
    </StyledHeroWrapper>
  );
}
